import React from 'react';
import { Link, useLocation } from 'wouter';

export function NavLink({ to, children }: { to: string; children: React.ReactNode; }) {
    const [location] = useLocation();
    return <Link href={to} className={location.startsWith(to) ? "active" : ""}>
        {children}
    </Link>;
}
